// third-party
import { presetPalettes } from '@ant-design/colors';

// project imports
import ThemeOption from './theme';
import { extendPaletteWithChannels } from 'utils/colorUtils';

const greyAscent = ['#fafafa', '#bfbfbf', '#434343', '#1f1f1f'];

// ==============================|| GREY COLORS BUILDER ||============================== //

function buildGrey(): string[] {
  const greyPrimary = [
    '#ffffff',
    '#fafafa',
    '#f5f5f5',
    '#f0f0f0',
    '#d9d9d9',
    '#bfbfbf',
    '#8c8c8c',
    '#595959',
    '#262626',
    '#141414',
    '#000000'
  ];
  const greyConstant = ['#fafafb', '#e6ebf1'];

  return [...greyPrimary, ...greyAscent, ...greyConstant];
}

// ==============================|| DEFAULT THEME - PALETTE ||============================== //

export function buildPalette(presetColor?: string) {
  const lightColors = { ...presetPalettes, grey: buildGrey() };
  const lightPaletteColor = ThemeOption(lightColors as Parameters<typeof ThemeOption>[0]);

  const commonColor = { common: { black: '#000', white: '#fff' } };

  const extendedLight = extendPaletteWithChannels(lightPaletteColor as Record<string, unknown>);
  const extendedCommon = extendPaletteWithChannels(commonColor as Record<string, unknown>);

  const light = extendedLight as typeof lightPaletteColor & { [key: string]: unknown };

  return {
    light: {
      mode: 'light' as const,
      ...extendedCommon,
      ...extendedLight,
      text: {
        primary: (light.grey as Record<string | number, string>)[700],
        secondary: (light.grey as Record<string | number, string>)[500],
        disabled: (light.grey as Record<string | number, string>)[400]
      },
      action: { disabled: (light.grey as Record<string | number, string>)[300] },
      divider: (light.grey as Record<string | number, string>)[200],
      background: {
        paper: (light.grey as Record<string | number, string>)[0],
        default: (light.grey as Record<string | number, string>)['A50']
      }
    }
  };
}
